import { useAuthContext } from '../contexts/AuthContext';
import type { AppRole } from '../services/apiService';

export interface UseApiAuthResult {
  /** Whether the API is ready to make authenticated requests */
  isApiReady: boolean;
  /** Whether authentication is currently in progress */
  isLoading: boolean;
  /** Whether an interactive login is being started (click-lock) */
  isStartingInteraction: boolean;
  /** Any error that occurred during token acquisition */
  error: string | null;
  /** Whether an authentication attempt has been made */
  hasAttemptedAuth: boolean;
  /** App RBAC roles from GET /me/roles */
  appRoles: AppRole[];
  /** Whether /me/roles has been fetched for the current session */
  appRolesLoaded: boolean;
  /** Re-fetch app RBAC roles */
  refreshAppRoles: () => Promise<void>;
  /** Function to manually retry silent token acquisition */
  retryAuth: () => Promise<boolean>;
  /** Starts an interactive login (popup) via the centralized auth flow */
  beginInteractiveLogin: () => Promise<void>;
}

/**
 * Custom hook for handling MSAL authentication and API token setup
 * Now uses the shared AuthContext to ensure state consistency across components.
 */
export const useApiAuth = (): UseApiAuthResult => {
  return useAuthContext();
};
